if (!customElements.get("info-modal")) {
  class InfoModal extends HTMLElement {
    constructor() {
      super();

      this.name = this.dataset.name;

      this.overlay = this.querySelector(".overlay");
      this.content = this.querySelector(".content");

      this.isClosing = false;
      this.isExpanding = false;

      document.body.addEventListener("click", (e) => {
        const btn = e.target.closest(`[open-modal="${this.name}"]`);
        if (btn) {
          this.open();
        }
      });
      this.querySelectorAll("[close-modal]").forEach(el => el.addEventListener("click", this.close.bind(this)));
      this.overlay.addEventListener("click", this.close.bind(this));
    }

    open() {
      this.classList.add("open");
      document.body.style.overflow = "hidden";

      if (window.innerWidth < 1024) {
        window.requestAnimationFrame(() => this.expand());
      }
    }

    close() {
      if (window.innerWidth < 1024) {
        window.requestAnimationFrame(() => this.shrink());
      } else {
        this.classList.remove("open");
      }
      document.body.style.overflow = "unset";
    }

    expand() {
      if (this.isExpanding || this.isClosing) {
        return;
      }

      this.isExpanding = true;
      this.isClosing = false;

      this.endHeight = `${this.content.offsetHeight}px`;

      const overlayAnimation = this.overlay.animate({ opacity: [0, 100]}, {
        duration: 150,
        easing: "ease-out"
      });

      overlayAnimation.onfinish = () => this.overlay.style.opacity = 100;

      // Start a WAAPI animation
      const contentAnimation = this.content.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [0, this.endHeight]
      }, {
        duration: 400,
        easing: "ease-out"
      });

      // When the animation is complete, call onAnimationFinish()
      contentAnimation.onfinish = () => {
        this.content.style.height = this.endHeight;
        this.isExpanding = false;
      };
      // If the animation is cancelled, isExpanding variable is set to false
      contentAnimation.oncancel = () => this.isExpanding = false;
    }

    shrink() {
      if (this.isExpanding || this.isClosing) {
        return;
      }

      this.isExpanding = false;
      this.isClosing = true;

      const overlayAnimation = this.overlay.animate({ opacity: [100, 0] }, {
        duration: 150,
        easing: "ease-out"
      });

      overlayAnimation.onfinish = () => this.overlay.style.opacity = 0;

      // Start a WAAPI animation
      const contentAnimation = this.content.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [this.endHeight, 0]
      }, {
        duration: 400,
        easing: "ease-out"
      });

      // When the animation is complete, call onAnimationFinish()
      contentAnimation.onfinish = () => {
        this.content.style.height = null;
        this.endHeight = null;
        this.isClosing = false;
        this.classList.remove("open");
      };
      // If the animation is cancelled, isExpanding variable is set to false
      contentAnimation.oncancel = () => {
        this.isClosing = false;
        this.classList.remove("open");
      };
    }
  }

  window.customElements.define("info-modal", InfoModal);
}
